import { render, staticRenderFns } from "./message-footer.vue?vue&type=template&id=49fecf74&scoped=true"
import script from "./message-footer.vue?vue&type=script&lang=js"
export * from "./message-footer.vue?vue&type=script&lang=js"
import style0 from "./message-footer.vue?vue&type=style&index=0&id=49fecf74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fecf74",
  null
  
)

export default component.exports